import React from 'react';
import styled from 'styled-components';
import VideoCreator from 'app/components/tv/models/VideoCreator';
const Wrapper = styled.div.withConfig({
  componentId: "sc-dmt97i-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;align-items:center;"]);
const LogoContainer = styled.div.withConfig({
  componentId: "sc-dmt97i-1"
})(["display:flex;aspect-ratio:16/9;justify-content:flex-end;align-items:flex-start;padding:2%;@media screen and (max-aspect-ratio:16 / 9){width:100vw;}@media screen and (min-aspect-ratio:16 / 9){height:100vh;}"]);
function FuPaTvLogo(_ref) {
  let {
    video
  } = _ref;
  const videoObj = VideoCreator.createVideo(video);
  return videoObj.showFuPaTvLogo() ? /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "FuPaTvLogo",
    "data-sentry-source-file": "FuPaTvLogo.tsx"
  }, /*#__PURE__*/React.createElement(LogoContainer, {
    "data-sentry-element": "LogoContainer",
    "data-sentry-source-file": "FuPaTvLogo.tsx"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/fupa-tv-logo-20.svg",
    alt: "Zur FuPa-Startseite",
    width: "15%",
    height: "auto"
  }))) : null;
}
export default FuPaTvLogo;